import React, { useEffect, useRef } from 'react';
import { useGLTF, OrbitControls, Stars, useTexture } from "@react-three/drei";
import { Canvas, useFrame } from '@react-three/fiber';
import './Mountain.css'
const Lights = () => {
  return (
    <>
      <ambientLight intensity={.3} />
      <directionalLight position={[10, 10, 5]} intensity={1} />
    </>
  )
};
const Clouds = () => {
  const cloud_texture = useTexture('/smoke2.png');
  let my_position = [0, -49.3, 0];
  let my_rotation = [-Math.PI / 2, 0, 0];
  const mesh = useRef();
  useFrame((state, delta) => (mesh.current.rotation.z -= 0.0005))
  return (
    <mesh position={my_position} ref={mesh} rotation={my_rotation} material={{ opacity: 1 }}>
      <meshLambertMaterial map={cloud_texture} transparent={true} />
      <planeBufferGeometry attach="geometry" args={[600, 600]} />
    </mesh>
  )
};

const Mountain = (props) => {
  const gltf = useGLTF('/scene.glb');
  const canvasRef = useRef()
  useEffect(() => console.log(canvasRef), [])


  return (
    <Canvas ref={canvasRef} className="mountain-canvas" colorManagement camera={{ position: [-120, 0, 120], fov: 70 }}>
      <OrbitControls maxPolarAngle={[Math.PI / 1.65]} maxDistance={135} minDistance={50} />
      <Stars />
      <Lights />


      {props.show3D ?
        <>
          <fog attach="fog" args={["white", 100, 200]} />
          <mesh position={[0, -50, 0]}>
            <primitive object={gltf.scene} dispose={null} />
          </mesh>
          <Clouds />
        </>
        : null
      }






    </Canvas>
  )
};

useGLTF.preload('/scene.glb')

export default Mountain

